export const revision = 'b06fb0c5a69cc73ee6ab181176eebe42096d28f6';
